import React from "react";
import _pubA97D53F3 from "./atoms.pc";
import _pubBab5A68F, {Preview as _pubBab5A68F_Preview} from "./utils.pc";
import "./Help.pc.css";
function getDefault(module) {
  return module.default || module;
}

function castStyle(value) {
  var tov = typeof value;
  if (tov === "object" || tov !== "string" || !value) return value;
  return value.trim().split(";").reduce(function (obj, keyValue) {
    var kvp = keyValue.split(":");
    var key = kvp[0];
    var value = kvp[1];
    if (!value || value === "undefined") return obj;
    var trimmedValue = value.trim();
    if (trimmedValue === "undefined" || !trimmedValue) return obj;
    obj[key.trim()] = trimmedValue;
    return obj;
  }, {});
}

export const classNames = {

};

var $$Default = React.memo(React.forwardRef(function $$Default(props, ref) {
  return React.createElement("div", {
    "className": "_5ad25d11 _7d0904ad _pub-7d0904ad _pub-a97d53f3" + (props["class"] ? " " + props["class"] : "") + " " + " " + (props["className"] ? " " + props["className"] : "") + (props["nofilter"] ? " " + "_7d0904ad_nofilter _pub-7d0904ad_nofilter _pub-a97d53f3_nofilter nofilter" : ""),
    "ref": ref,
    "data-testid": props["testId"],
  }, 
    props["icon"]&&React.createElement("div", {
      "className": "_557c6243 _7d0904ad _pub-7d0904ad _pub-a97d53f3",
    }, 
      props["icon"]
    ),
    props["content"]||props["children"]
  )
}));
export default $$Default;


